import {
	ProfileIcon,
	ProfileOutlineIcon,
	DebitCardIcon,
	TransactioIcon,
} from '@shared/assets/icons';
import { Translation } from '@shared/config/i18n';
import { PATHS } from '@shared/constants';

export const userNavLib = (tT) => [
	{
		to: PATHS.user.PROFILE,
		label: tT(Translation.USER_NAV_PROFILE),
		icon: ProfileOutlineIcon,
		activeIcon: ProfileIcon,
	},
	{
		to: PATHS.user.YOURDEBITCARD,
		label: tT(Translation.USER_NAV_YOUR_DEBIT_CARD),
		icon: DebitCardIcon,
		activeIcon: DebitCardIcon, // если нет отдельной filled версии
	},
	{
		to: PATHS.user.TRANSACTIONS,
		label: tT(Translation.USER_NAV_YOUR_TRANSACTIONS),
		icon: TransactioIcon,
		activeIcon: TransactioIcon,
	},
];
